/**
 * ANQ.ContentServiceManagement.API 
 * Content Service Mgt API
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CommandRecord } from '../model/commandRecord';
import { ContentProvider } from '../model/contentProvider';
import { ContentProviderContentDto } from '../model/contentProviderContentDto';
import { ContentProviderCount } from '../model/contentProviderCount';
import { ContentProvidersDto } from '../model/contentProvidersDto';
import { CreateContentProvider } from '../model/createContentProvider';
import { ProblemDetails } from '../model/problemDetails';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ContentProviderService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiContentProviderCreateContentProviderPost(body?: CreateContentProvider, observe?: 'body', reportProgress?: boolean): Observable<ContentProvider>;
    public apiContentProviderCreateContentProviderPost(body?: CreateContentProvider, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ContentProvider>>;
    public apiContentProviderCreateContentProviderPost(body?: CreateContentProvider, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ContentProvider>>;
    public apiContentProviderCreateContentProviderPost(body?: CreateContentProvider, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ContentProvider>('post',`${this.basePath}/api/ContentProvider/CreateContentProvider`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param skip 
     * @param take 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiContentProviderGetAllGet(skip?: number, take?: number, observe?: 'body', reportProgress?: boolean): Observable<ContentProviderCount>;
    public apiContentProviderGetAllGet(skip?: number, take?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ContentProviderCount>>;
    public apiContentProviderGetAllGet(skip?: number, take?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ContentProviderCount>>;
    public apiContentProviderGetAllGet(skip?: number, take?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('skip', <any>skip);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ContentProviderCount>('get',`${this.basePath}/api/ContentProvider/GetAll`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param authId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiContentProviderGetByContentProviderAndContentByAuthIdAuthIdGet(authId: string, observe?: 'body', reportProgress?: boolean): Observable<ContentProviderContentDto>;
    public apiContentProviderGetByContentProviderAndContentByAuthIdAuthIdGet(authId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ContentProviderContentDto>>;
    public apiContentProviderGetByContentProviderAndContentByAuthIdAuthIdGet(authId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ContentProviderContentDto>>;
    public apiContentProviderGetByContentProviderAndContentByAuthIdAuthIdGet(authId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (authId === null || authId === undefined) {
            throw new Error('Required parameter authId was null or undefined when calling apiContentProviderGetByContentProviderAndContentByAuthIdAuthIdGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ContentProviderContentDto>('get',`${this.basePath}/api/ContentProvider/GetByContentProviderAndContentByAuthId/${encodeURIComponent(String(authId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param email 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiContentProviderGetByContentProviderEmailGet(email?: string, observe?: 'body', reportProgress?: boolean): Observable<ContentProvider>;
    public apiContentProviderGetByContentProviderEmailGet(email?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ContentProvider>>;
    public apiContentProviderGetByContentProviderEmailGet(email?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ContentProvider>>;
    public apiContentProviderGetByContentProviderEmailGet(email?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (email !== undefined && email !== null) {
            queryParameters = queryParameters.set('email', <any>email);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ContentProvider>('get',`${this.basePath}/api/ContentProvider/GetByContentProviderEmail`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param CpId 
     * @param contentProviderId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiContentProviderGetByContentProviderIdCpIdGet(CpId: string, contentProviderId?: string, observe?: 'body', reportProgress?: boolean): Observable<ContentProvidersDto>;
    public apiContentProviderGetByContentProviderIdCpIdGet(CpId: string, contentProviderId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ContentProvidersDto>>;
    public apiContentProviderGetByContentProviderIdCpIdGet(CpId: string, contentProviderId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ContentProvidersDto>>;
    public apiContentProviderGetByContentProviderIdCpIdGet(CpId: string, contentProviderId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (CpId === null || CpId === undefined) {
            throw new Error('Required parameter CpId was null or undefined when calling apiContentProviderGetByContentProviderIdCpIdGet.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (contentProviderId !== undefined && contentProviderId !== null) {
            queryParameters = queryParameters.set('contentProviderId', <any>contentProviderId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ContentProvidersDto>('get',`${this.basePath}/api/ContentProvider/GetByContentProviderId/${encodeURIComponent(String(CpId))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiContentProviderGetByIdGet(id?: string, observe?: 'body', reportProgress?: boolean): Observable<ContentProvidersDto>;
    public apiContentProviderGetByIdGet(id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ContentProvidersDto>>;
    public apiContentProviderGetByIdGet(id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ContentProvidersDto>>;
    public apiContentProviderGetByIdGet(id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ContentProvidersDto>('get',`${this.basePath}/api/ContentProvider/GetById`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param clientId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiContentProviderGetCommandRecordByClientIdGet(clientId?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<CommandRecord>>;
    public apiContentProviderGetCommandRecordByClientIdGet(clientId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CommandRecord>>>;
    public apiContentProviderGetCommandRecordByClientIdGet(clientId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CommandRecord>>>;
    public apiContentProviderGetCommandRecordByClientIdGet(clientId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (clientId !== undefined && clientId !== null) {
            queryParameters = queryParameters.set('clientId', <any>clientId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<CommandRecord>>('get',`${this.basePath}/api/ContentProvider/GetCommandRecordByClientId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param name 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiContentProviderGetContentproviderByNameGet(name?: string, observe?: 'body', reportProgress?: boolean): Observable<ContentProvider>;
    public apiContentProviderGetContentproviderByNameGet(name?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ContentProvider>>;
    public apiContentProviderGetContentproviderByNameGet(name?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ContentProvider>>;
    public apiContentProviderGetContentproviderByNameGet(name?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (name !== undefined && name !== null) {
            queryParameters = queryParameters.set('name', <any>name);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ContentProvider>('get',`${this.basePath}/api/ContentProvider/GetContentproviderByName`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param authId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiContentProviderGetContentproviderIdByAuthIdGet(authId?: string, observe?: 'body', reportProgress?: boolean): Observable<ContentProvider>;
    public apiContentProviderGetContentproviderIdByAuthIdGet(authId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ContentProvider>>;
    public apiContentProviderGetContentproviderIdByAuthIdGet(authId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ContentProvider>>;
    public apiContentProviderGetContentproviderIdByAuthIdGet(authId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (authId !== undefined && authId !== null) {
            queryParameters = queryParameters.set('authId', <any>authId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ContentProvider>('get',`${this.basePath}/api/ContentProvider/GetContentproviderIdByAuthId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param skip 
     * @param take 
     * @param search 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiContentProviderGetGet(skip?: number, take?: number, search?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ContentProvider>>;
    public apiContentProviderGetGet(skip?: number, take?: number, search?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ContentProvider>>>;
    public apiContentProviderGetGet(skip?: number, take?: number, search?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ContentProvider>>>;
    public apiContentProviderGetGet(skip?: number, take?: number, search?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('skip', <any>skip);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('search', <any>search);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ContentProvider>>('get',`${this.basePath}/api/ContentProvider/Get`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
